import { z } from "zod";

/**
 * Adds email confirmation validation to a schema.
 * Requires the schema to have `email` and `confirmEmail` fields.
 *
 * @example
 * const schema = withEmailConfirmation(z.object({
 *   email: emailField,
 *   confirmEmail: confirmEmailField,
 *   firstName: firstNameField,
 *   // ... other fields
 * }));
 */
export const withEmailConfirmation = <
  T extends z.ZodObject<
    z.ZodRawShape & {
      email: z.ZodString;
      confirmEmail: z.ZodString;
    }
  >
>(
  schema: T
): z.ZodEffects<T, z.infer<T>, z.infer<T>> =>
  schema.refine((data) => data.email === data.confirmEmail, {
    message: "Email addresses must match",
    path: ["confirmEmail"],
  });

